let configData = window.Drupal && Drupal.settings.employment ? Drupal.settings.employment : {};

if (!configData.disclaimer) {
	configData.disclaimer = `
	<p>
		I certify all of the facts and statements as set forth in this employment application are true and complete. I understand and agree that if employed, any falsification or omission of information shall be considered grounds for immediate dismissal.
	</p>
	<p>
		I herby authorize you to conduct a full investigation of my personal, educational and employment history through the use of whatever investigative agencies or bureaus you may choose. I also specifically authorize you to contact my PREVIOUS employers and authorize them to provide any information or references that you deem necessary in connection with this application.
	</p>
	<p>
		It is unlawful in Massachusetts to require or administer a lie detector test as a condition of employment or continued employment. An employer who violates this law shall be subject to criminal penalties and civil liability.
	</p>
	<p>
		I understand that no verbal promises or guarantees relating to employment that are binding upon the Company and that, if employed I will be an employee “at will” and may be terminated at any time. If I am employed, I agree to abide by the Company’s rules and regulations and any changes thereto.
	</p>
	`;
}

if (configData.theater) {
	configData.askAboutCrime = configData.crimeQuestionTheaters.indexOf(parseInt(configData.theater.house_id)) != -1;
	configData.askAboutWages = configData.wagesQuestionTheaters.indexOf(parseInt(configData.theater.house_id)) != -1;
}

const config = (state = configData, action) => {
	//this reducers only job is to initialize the default state for the config object

	let testConfig = {
		askAboutCrime: false,
		askAboutWages: false,
		crimeQuestionTheaters: [
			352, 4035, 25, 1095, 6924, 8274, 27362, 8571
		],
		theater: {
			"title": "Blackstone Valley 14: Cinema de Lux",
			"pageTitle": "Millbury - Blackstone Valley 14: Cinema de Lux - Showcase Cinema",
			"theatre_id": "786",
			"image_url": "https://www.showcasecinemas.com/sites/default/files/images/BlackstoneXPLUS300x250.jpg",
			"hero_image": "https://www.showcasecinemas.com/sites/default/files/reseatedheader.jpg",
			"events": [],
			"house_id": "8703",
			"house_name": "Blackstone Valley 14",
			"theatre_type": "Cinema de Lux",
			"location": "Intersection of Routes 146 and 122A",
			"address": "70 Worcester/Providence Tpke",
			"city": "Millbury",
			"state": "MA",
			"zip": "01527",
			"country": "USA",
			"county": "Worcester",
			"technologies": [{
					"tip": "Dolby",
					"url": "/theatres/theatre-technology",
					"image_url": "/sites/all/themes/showcase/imgs/dolby.png",
					"id": "technology_dolby"
				},
				{
					"tip": "RealD 3D",
					"url": "/theatres/theatre-technology",
					"image_url": "/sites/all/themes/showcase/imgs/reald.png",
					"id": "technology_reald_3d"
				},
				{
					"tip": "MoPIX",
					"url": "/theatres/theatre-technology",
					"image_url": "/sites/all/themes/showcase/imgs/mopix.png",
					"id": "technology_mopix"
				},
				{
					"tip": "Sony 4K",
					"url": "/theatres/theatre-technology",
					"image_url": "/sites/all/themes/showcase/imgs/sony4k.png",
					"id": "technology_sony_4k"
				},
				{
					"tip": "XPlus",
					"url": "/theatres/theatre-technology",
					"image_url": "/sites/all/themes/showcase/imgs/xplus.png",
					"id": "technology_xplus"
				}
			],
			"numscreens": "14",
			"lat": "42.1954",
			"lon": "-71.7759",
			"amenities": [{
					"title": "Chatters Bar & Grill",
					"image": "https://www.showcasecinemas.com/sites/default/files/images/bentobocthumb.jpg",
					"description": "Chatters Bar &amp; Grill is a full service restaurant and cocktail lounge featuring American fare in a relaxed, sophisticated setting. Guests can enjoy dinner and/or drinks before or after the movie, or just stop by to meet friends for lunch, dinner or watch the game. \n",
					"url": "/dining/chatters-bar-grill",
					"menu": "https://www.showcasecinemas.com/sites/default/files/menuBblackstone.pdf"
				},
				{
					"title": "Food Court",
					"image": "https://www.showcasecinemas.com/sites/default/files/images/concessionthumbstand.jpg",
					"description": "Our theatre lobby food courts have something for everyone! Indulge in a slice of freshly baked Famous Famiglia Pizza®, Ben &amp; Jerry's ice cream, a delicious Starbucks™ latte, Nathans Famous® hot dogs, burgers, and much more...\n",
					"url": "/dining/food-court",
					"menu": ""
				},
				{
					"title": "Main Concessions",
					"image": "https://www.showcasecinemas.com/sites/default/files/mainconcessionsthumbwoutcoke.jpg",
					"description": "Our Concession Stands offer a wide variety of classic movie fare such as popcorn, nachos, premium movie candy, Coke® soft drinks, and much more...\n",
					"url": "/dining/main-concessions",
					"menu": ""
				}
			],
			"description": "<p>The Blackstone Valley 14: Cinema de Lux movie theatre features <a href=\"http://www.showcasecinemas.com/dining/chatters-bar-grill\">Chatters Bar &amp; Grill</a> and in-theatre dining options serving both food and alcohol at your seat. Other features include <a href=\"http://www.showcasecinemas.com/business/meetings-events\">conference</a> and <a href=\"http://www.showcasecinemas.com/programs/kids-and-families/movie-party\">party theatre rentals</a> and the <a href=\"http://www.showcasestarpass.com/\">Starpass</a> rewards program for earning additional perks each visit. Showcase Cinema de Lux Blackstone Valley, a Millbury movie theatre, services surrounding communities including Grafton, Sutton, Oxford, Auburn, and others</p>",
			"features": [{
					"id": "feature_accessibility",
					"title": "Handicap Accessible"
				},
				{
					"id": "feature_at_home_ticketing",
					"title": "Print At Home Ticketing"
				},
				{
					"id": "feature_digital_sound",
					"title": "Assistive Listening Devices"
				},
				{
					"id": "feature_stadium_seating",
					"title": "All Stadium Seating"
				}
			],
			"show_events": true,
			"showtime_link": "/theatre/8703/blackstone-valley-14-cinema-de-lux/millbury/ma",
			"theatre_detail_link": "/theatre/8703/blackstone-valley-14-cinema-de-lux/millbury/ma",
			"ad": "<a href=\"https://www.showcasecinemas.com/movie/incredibles-2?utm_source=internalpage&amp;utm_medium=promotile&amp;utm_campaign=incredibles2\" title=\"The incredibles 2\"><img src='https://www.showcasecinemas.com/sites/default/files/INCREDIBLES1000X125XPLUS_0.jpg' alt='The Incredibles 2'/></a>",
			"ads": [],
			"age_policy": null,
			"movies": [],
			"nearbyTheatres": [],
			"fandangoTheatreId": "AARVV"
		},
		wagesQuestionTheaters: []
	}

	return testConfig;
}

export default config;